import { ProjectType } from "../../../common/constants"
import api from "../../api"

export type ManHoursReportData = {
  projects: ManHoursReportProject[],
  actualDirectLaborEfficiencyRatio: number;
  actualDirectLaborRevenueRatio: number;
  actualNetProfitPerManHour: number;
  actualRevenuePerManHour: number;
  actualThroughputPerManHour: number;
  estimatedDirectLaborEfficiencyRatio: number;
  estimatedDirectLaborRevenueRatio: number;
  estimatedNetProfitPerManHour: number;
  estimatedRevenuePerManHour: number;
  estimatedThroughputPerManHour: number;
  estimatedGrossProfitPerManHour: number;
  actualGrossProfitPerManHour: number;
  estimatedManHours: number;
  actualManHours: number;
}

export type ManHoursReportProject = {
  projectId: number,
  jobName: string,
  jobType: ProjectType,
  jobTypeName?: string,
  customerId: number,
  customerDisplayName: string,
  propertyId: number,
  address1: string,
  city: string,
  state: string,
  zip: number,
  salesPersonName: string,
  isSold: boolean,
  divisionId: number,
  divisionName: string,
  projectWorkareaId: number,
  projectWorkareaName: string,
  estimatedManHours: number,
  actualManHours: number,
}

export type ManHoursProjectData = {
  projectId: number,
  jobName: string,
  jobType: ProjectType,
  jobTypeName?: string,
  salesPersonEmail: string;
  salesPersonDisplayName: string;
  isSold: boolean
  customerId: number;
  customerDisplayName: string;
  divisionId: number;
  divisionName: string;
  propertyId: number;
  address1: string;
  city: string;
  state: string;
  zip: number;
  estimatedPriceFinal: number;
  projectWorkareaId: number;
  projectWorkareaName: string;
  actualPriceFinal: number;
  actualLaborQty: number;
  estimatedLaborQty: number;
  estimatedEquipmentCost: number;
  estimatedMaterialsCost: number;
  estimatedLaborCost: number;
  estimatedSubcontractingCost: number;
  estimatedOverhead: number;
  actualEquipmentCost: number;
  actualMaterialsCost: number;
  actualLaborCost: number;
  actualSubcontractingCost: number;
  actualOverhead: number;
}

export const getManHoursProjectsData = async (startDate?: string, endDate?: string): Promise<ManHoursProjectData[]> => {
  return (await api.get(`/web/datacenter/man-hours/${startDate}/${endDate}`)).data
} 